export { default } from '@material-ui/core/AppBar';

export type AppBarProps = import('@material-ui/core/AppBar').AppBarProps;
